import { render } from "./MarkdownRenderer.vue?vue&type=template&id=65dce1f3"
import script from "./MarkdownRenderer.vue?vue&type=script&lang=js"
export * from "./MarkdownRenderer.vue?vue&type=script&lang=js"

import "./MarkdownRenderer.vue?vue&type=style&index=0&id=65dce1f3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__